export enum HalfArea {
    UpperArea,
    LowerArea
}